import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export type AgencyIntent =
  | 'catalog_clean'
  | 'studio_model'
  | 'customer_tryon'
  | 'lifestyle_shoot'
  | 'marketing_design';

export type AgencyPlan = {
  intent: AgencyIntent;
  qualityMode: 'preview' | 'publish' | 'hd';
  canonicalAspectRatio: 'preserve' | '1:1' | '3:4' | '4:5' | '9:16';
  steps: Array<{ role: string; action: string; required: boolean }>;
  providerShortlist: Array<{
    id: string;
    provider: 'fashn' | 'gemini' | 'openai';
    capability: string;
    model: string;
    priority: number;
    reason: string;
  }>;
  qaRules: Array<{ id: string; label: string; severity: 'blocker' | 'warning' | 'info' }>;
};

export function useAgencyPlan(intent: AgencyIntent) {
  return useQuery({
    queryKey: ['agency-plan', intent],
    queryFn: () => api<AgencyPlan>(`/agency/plan?intent=${intent}&qualityMode=publish`),
  });
}
